// A leaf module on purpose: these two predicates are the first thing any error
// handler reaches for, and importing them from ./index used to drag the whole
// generated SDK and the configured HTTP client in behind them — which is why a
// plain unit test of sync-helpers could not load without a browser's worth of
// dependencies. ./index re-exports both, so existing importers are unaffected.
import type { HttpExceptionModel, HttpValidationError } from "./gen/types.gen";

type ErrorWithDetail = {
    detail: Array<object>;
};

const errorHasDetailArray = (error: unknown): error is ErrorWithDetail => {
    return (
        error instanceof Object &&
        "detail" in error &&
        error.detail instanceof Array &&
        // Guarded: both predicates below index into detail[0], and an `in`
        // against undefined throws — inside an error handler, of all places.
        error.detail.length > 0
    );
};

/**
 * Check whether error is a HttpValidationError.
 *
 * True for anything shaped like FastAPI's own validation payload
 * (`detail[].loc`) — which covers endpoints that build an HTTPException detail
 * by hand to put a message next to a specific form field, as
 * update_business_entity does for a duplicate object name. Those carry no
 * `type`, so isHttpExceptionModel does NOT recognise them.
 */
export const isHttpValidationError = (
    error: unknown
): error is HttpValidationError => {
    if (errorHasDetailArray(error)) {
        return "loc" in error.detail[0];
    } else {
        return false;
    }
};

/**
 * Check whether error is a isHttpExceptionModel.
 */
export const isHttpExceptionModel = (
    error: unknown
): error is HttpExceptionModel => {
    if (errorHasDetailArray(error)) {
        return "type" in error.detail[0];
    } else {
        return false;
    }
};
